import script from "./BaseDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDialog.vue?vue&type=style&index=0&id=ab166b88&lang=scss"

const __exports__ = script;

export default __exports__